import { useEffect } from 'react';
import NavLink from './NavLink';
import type { NavLinksViewProps } from './types';

export default function NavLinks({
  navLinks,
  promo,
  currencyCode,
  onPromoTermsClick,
  isGlobalEFlag,
  isGlobalESite,
}: NavLinksViewProps) {
  useEffect(() => {
    function a(elm: HTMLElement) {
      let b = 0;
      const categorybgElements = elm.querySelectorAll('.categorybg');

      if (categorybgElements.length) {
        const f = categorybgElements[0].getBoundingClientRect().left + 10;
        const firstRowDivs = elm.querySelectorAll('.cn-row:first-child > div');

        firstRowDivs.forEach(div => {
          const k = div;
          b = b + parseInt(window.getComputedStyle(k).width, 10) + parseFloat(window.getComputedStyle(k).marginLeft);
        });

        const categorybgcolorElements = elm.querySelectorAll('.categorybgcolor') as any;
        categorybgcolorElements[0].style.left = `${f}px`;

        const diamondQuizTopElements = document.querySelectorAll('.diamond-quiz-top') as any;
        if (diamondQuizTopElements.length) {
          const e = diamondQuizTopElements[0].getBoundingClientRect().left;
          const diamondQuizTopParentWidth = diamondQuizTopElements[0]?.parentNode?.offsetWidth;
          diamondQuizTopElements[0].style.marginRight = `${diamondQuizTopParentWidth - (f - e - 15)}px`;
        }
      }
    }

    const kingNavgationItems = document.querySelectorAll('.king-navgation > li');

    kingNavgationItems.forEach(item => {
      item.addEventListener('mouseover', function () {
        const currentThis = this as HTMLElement;
        const subnavContent = currentThis?.querySelector('.subnav-content');

        if (subnavContent?.querySelector('div.categorybgcolor')) {
          const categorybgcolor = document.createElement('div');
          categorybgcolor.className = 'categorybgcolor';
          subnavContent.appendChild(categorybgcolor);
        }

        a(currentThis);
      });
    });
  }, []);

  return (
    <ul className="king-navgation list-inline selected-navigation-color avenir-roman">
      {navLinks?.map((navLink: any, index: number) => (
        <NavLink
          key={index}
          navLink={navLink}
          itemIndex={index}
          totalItems={navLinks.length}
          promo={promo}
          currencyCode={currencyCode}
          onPromoTermsClick={onPromoTermsClick}
          isGlobalEFlag={isGlobalEFlag}
          isGlobalESite={isGlobalESite}
        />
      ))}
    </ul>
  );
}
